import React, { useState, useEffect, useContext } from "react";

import {
  IconButton,
  Paper,
  TableContainer,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Table,
  Stack,
  Button,
  Tooltip,
} from "@mui/material";
import AddRoundedIcon from "@mui/icons-material/AddRounded";
import EditRoundedIcon from "@mui/icons-material/EditRounded";
import DeleteRoundedIcon from "@mui/icons-material/DeleteRounded";
import { isEmpty } from "lodash";
import { DataContext } from "../../../context/DataContext";
import { isAccess, simpleMessage } from "../../../helpers/Helpers";
import { deleteToken, deleteUserData, getToken } from "../../../api/Account";
import NoData from "../../../components/NoData";
import ListFooter from "../../../components/ui/ListFooter";
import {
  deleteIntCorrienteAsync,
  getInteresListAsync,
} from "../../../api/InteresCorriente";
import SmallModal from "../../../components/modals/SmallModal";
import AddTasaInteres from "./AddTasaInteres";
import { EditTasaInteres } from "./EditTasaInteres";
import Swal from "sweetalert2";
import { monoFont, getTokens } from "../../../theme";

const MainInteresCorriente = () => {
  const [interesCorrienteList, setInteresCorrienteList] = useState([]);
  const [selectedIC, setSelectedIC] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);

  const [localReload, setLocalReload] = useState(false);

  const { access, setIsLoading, setIsLogged, setIsUnautorized, isDarkMode } =
    useContext(DataContext);
  const t = getTokens(isDarkMode);

  const token = getToken();

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      const result = await getInteresListAsync(token);
      if (!result.statusResponse) {
        setIsLoading(false);
        if (result.error === "Unauthorized") {
          setIsUnautorized(true);
          return;
        }
        simpleMessage(result.error, "error");
        return;
      }

      setIsLoading(false);
      setInteresCorrienteList(result.data.result);
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [localReload]);

  const [currentPage, setCurrentPage] = useState(1);
  const [itemsperPage] = useState(10);
  const indexLast = currentPage * itemsperPage;
  const indexFirst = indexLast - itemsperPage;
  const currentItem = interesCorrienteList.slice(indexFirst, indexLast);
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const deleteIC = async (item) => {
    Swal.fire({
      title: "¿Estas Seguro?",
      text: "No podras revertir esto...!",
      icon: "warning",
      showCancelButton: true,

      confirmButtonColor: "#1d4ed8",
      cancelButtonColor: "#d83a3f",

      confirmButtonText: "Eliminar!",
      cancelButtonText: "Cancelar",
      customClass: {
        popup: "border",
      },
    }).then((result) => {
      if (result.isConfirmed) {
        (async () => {
          setIsLoading(true);
          const result = await deleteIntCorrienteAsync(token, item.id);
          if (!result.statusResponse) {
            setIsLoading(false);

            if (result.error === "eX01") {
              deleteUserData();
              deleteToken();
              setIsLogged(false);
              return;
            }

            if (result.error === "Unauthorized") {
              setIsUnautorized(true);
              return;
            }
            simpleMessage(result.error, "error");
            return;
          }
          setIsLoading(false);
          setLocalReload(!localReload);

          Swal.fire("Eliminado!", "Tasa de Interes Eliminada.", "success");
        })();
      }
    });
  };

  const actionButtonSx = {
    width: 32,
    height: 32,
    borderRadius: "9px",
    border: `1px solid ${t.fieldLine}`,
    backgroundColor: t.field,
  };

  const puedeAccionar =
    isAccess(access, "CONFIG UPDATE") || isAccess(access, "CONFIG DELETE");

  return (
    <div>
      <Paper sx={{ overflow: "hidden" }}>
        <Stack
          direction={{ xs: "column", sm: "row" }}
          justifyContent="flex-end"
          alignItems={{ xs: "stretch", sm: "center" }}
          spacing={2}
          flexWrap="wrap"
          sx={{ padding: "18px 22px", borderBottom: "1px solid", borderColor: "divider" }}
        >
          {isAccess(access, "CONFIG CREATE") ? (
            <Button
              onClick={() => setShowModal(true)}
              startIcon={<AddRoundedIcon />}
              variant="contained"
              color="primary"
              sx={{ whiteSpace: "nowrap", height: "44px" }}
            >
              Agregar tasa de interés
            </Button>
          ) : null}
        </Stack>

        {isEmpty(currentItem) ? (
          <NoData />
        ) : (
          <>
            <TableContainer sx={{ overflowX: "auto" }}>
              <Table sx={{ minWidth: 480 }}>
                <TableHead>
                  <TableRow>
                    <TableCell align="center">#</TableCell>
                    <TableCell>Interés corriente</TableCell>
                    {puedeAccionar ? <TableCell align="center">Acciones</TableCell> : null}
                  </TableRow>
                </TableHead>

                <TableBody>
                  {currentItem.map((row) => {
                    const { id, intCorriente } = row;
                    return (
                      <TableRow key={id} hover>
                        <TableCell align="center" sx={{ color: "text.disabled", fontWeight: 600 }}>
                          {id}
                        </TableCell>
                        <TableCell
                          sx={{ fontFamily: monoFont, fontWeight: 700, color: "text.primary" }}
                        >
                          {intCorriente}%
                        </TableCell>
                        {puedeAccionar ? (
                          <TableCell align="center">
                            <Stack direction="row" spacing={1} justifyContent="center">
                              {isAccess(access, "CONFIG UPDATE") ? (
                                <Tooltip title="Editar">
                                  <IconButton
                                    size="small"
                                    sx={{ ...actionButtonSx, color: "warning.main" }}
                                    onClick={() => {
                                      setSelectedIC(row);
                                      setShowEditModal(true);
                                    }}
                                  >
                                    <EditRoundedIcon sx={{ fontSize: 15 }} />
                                  </IconButton>
                                </Tooltip>
                              ) : null}
                              {isAccess(access, "CONFIG DELETE") ? (
                                <Tooltip title="Eliminar">
                                  <IconButton
                                    size="small"
                                    sx={{ ...actionButtonSx, color: "error.main" }}
                                    onClick={() => deleteIC(row)}
                                  >
                                    <DeleteRoundedIcon sx={{ fontSize: 15 }} />
                                  </IconButton>
                                </Tooltip>
                              ) : null}
                            </Stack>
                          </TableCell>
                        ) : null}
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </TableContainer>

            <ListFooter
              data={interesCorrienteList}
              currentCount={currentItem.length}
              indexFirst={indexFirst}
              paginate={paginate}
              itemsperPage={itemsperPage}
              noun="tasas"
            />
          </>
        )}
      </Paper>

      <SmallModal
        titulo={"Agregar Tasa de Interes"}
        isVisible={showModal}
        setVisible={setShowModal}
      >
        <AddTasaInteres
          setShowModal={setShowModal}
          localReload={localReload}
          setLocalReload={setLocalReload}
        />
      </SmallModal>

      <SmallModal
        titulo={`Editar: ${selectedIC.intCorriente}`}
        isVisible={showEditModal}
        setVisible={setShowEditModal}
      >
        <EditTasaInteres
          selected={selectedIC}
          setShowModal={setShowEditModal}
        />
      </SmallModal>
    </div>
  );
};

export default MainInteresCorriente;
